// Una tarjeta que se pulsa, se arrastra y recibe lo que se suelta encima.
//
// El `<button>` crudo vive aqui, que es donde esta bien: la pieza es un boton
// -se pulsa, responde al teclado, se anuncia como tal- pero no es el componente
// `Button`, que trae su propia altura, su relleno y su alineado, y una tarjeta
// decide los tres por lo que lleva dentro.
//
// Estaba escrita dos veces en el explorador de herramientas -vista de lista y
// vista de rejilla-, con sus ocho manejadores de arrastre copiados en las dos.
// Cambiar el comportamiento del arrastre significaba acordarse de las dos.

import * as React from 'react'
import { cn } from '@/lib/utils'

export interface TarjetaArrastrableProps
  extends Omit<React.ComponentProps<'button'>, 'ref'> {
  /** Se marca cuando algo se esta arrastrando encima. */
  destinoDeSoltar?: boolean
  elegida?: boolean
}

export const TarjetaArrastrable = React.forwardRef<HTMLButtonElement, TarjetaArrastrableProps>(
  ({ destinoDeSoltar, elegida, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      draggable
      className={cn(
        'rounded-lg border bg-card/80 text-left transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        destinoDeSoltar
          ? 'border-primary bg-primary/10'
          : 'border-border hover:border-primary/40 hover:bg-card',
        elegida && 'border-primary',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
)
TarjetaArrastrable.displayName = 'TarjetaArrastrable'
